import { render, staticRenderFns } from "./DeadlineSelect.vue?vue&type=template&id=3ed31b58&"
import script from "./DeadlineSelect.vue?vue&type=script&lang=js&"
export * from "./DeadlineSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports